import { render, staticRenderFns } from "./QuaggaField.vue?vue&type=template&id=1429479f&scoped=true"
import script from "./QuaggaField.vue?vue&type=script&lang=js"
export * from "./QuaggaField.vue?vue&type=script&lang=js"
import style0 from "./QuaggaField.vue?vue&type=style&index=0&id=1429479f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429479f",
  null
  
)

export default component.exports